import { useSelector } from "react-redux";

export default function useDeviceTelemetries (deviceId, selector) {
  const telemetries = useSelector(state => {
    const deviceTelemetries = state.deviceService.deviceTelemetries[deviceId];
    return selector ? selector(deviceTelemetries) : deviceTelemetries;
  });

  return telemetries;
}